import { render } from "./SoutherPartView.vue?vue&type=template&id=b996bd36"
import script from "./SoutherPartView.vue?vue&type=script&lang=js"
export * from "./SoutherPartView.vue?vue&type=script&lang=js"

import "./SoutherPartView.vue?vue&type=style&index=0&id=b996bd36&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__